export const NEW_COMPANY_ID = 'NEW_COMPANY_ID'
export const DEFAULT_COMPANY_LOGO = '/static/images/default-company-logo.png'
